/**
 * The id a modifier-group member is stored under in a cart line.
 *
 * Four places build the flattened addons/options lists from the same menu
 * payload — the item modal (RestaurantDetail), both side carts, and the
 * checkout card — and a cart line saved by one is read back by the others via
 * `options.find(o => o._id === savedOption._id)`. They must agree exactly: a
 * member the reader keys differently is simply not found, and its line vanishes
 * from the cart while the group header still renders.
 *
 * `mk` is the caller's menu-scoping prefix (the same modifier on two menus
 * carries each menu's own marked-up price, so ids are per menu).
 */
export function modifierOptionId(mk, gm, entityId, isItem) {
  // Key by the MEMBERSHIP ROW, always.
  //
  // Everything that makes an option what it is — its price, its price mode, its
  // follow-up groups — lives on the membership row, not on the modifier. The
  // same modifier can be $2 and variant-priced in one group and free in
  // another, so keying by modifier id let the first group a modifier appeared
  // in decide the price shown everywhere else, and free options were billed as
  // paid ones. Item members are keyed the same way for the same reason; the
  // order payload carries itemId separately, so nothing downstream needs to
  // read the id back out.
  if (gm && gm._id != null) return mk(`gm_${gm._id}`);
  // No membership row (legacy shapes) — fall back to the entity's own id, item
  // ids and modifier ids being separate sequences that would otherwise collide.
  return mk(isItem ? `item_${entityId}` : String(entityId));
}
